import { themeAtom } from "../../../shared/atoms";
import Breadcrumb from "../../../shared/components/Breadcrumb";
import FileUploader from "../../../shared/components/FileUploader";
import HeaderTitle from "../../../shared/components/HeaderTitle";
import { useAtomValue } from "jotai";

interface Props {
  progressByFileName?: Record<string, number>;
}

const StepOne: React.FC<Props> = ({ progressByFileName }) => {
  const theme = useAtomValue(themeAtom);

  return (
    <div>
      <div className="mb-[32px] flex flex-col gap-[33px]">
        <HeaderTitle title={"Upload a certificate or document"} />
        <Breadcrumb currentStep={1} totalSteps={2} />
      </div>
      <div className={theme.vesselDetails.info}>
        <p className="mb-6 text-2xl font-semibold">Upload documents</p>
        <p className="mb-6">
          Select all the documents you wish to upload. You may upload documents related to different vessels at the same
          time.
        </p>
      </div>
      <FileUploader progressByFileName={progressByFileName} />
    </div>
  );
};

export default StepOne;
